// extracted by mini-css-extract-plugin
export default {"saleBannerText":"SQHZgJ","stackedTimer":"SFIMe7"};